import  React, {useEffect} from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {getAlerts} from '../../api/APIServices';
import {completePercent, getStatusColor} from '../../utils/utils';
import NumberCircle from '../../components/NumberCircle'
import TitleLink from '../../components/TitleLink';
import { useSelector, useDispatch } from 'react-redux';
import {formatPhoneNumber} from '../../utils/utils'
import { API_STATUS } from '../../constants';

function AlertBox() {
    const {t} = useTranslation('global');
    const dispatch  = useDispatch();
    const {userAlerts:rows, userAlertStatus} = useSelector((state)=> state.users );

    useEffect(() => {
        dispatch(getAlerts({isAlert:true}));
    },[]);

  
  return (
    <div className='half-container-ml'>
        <TitleLink
            enableLink={true}
            boxTitle={t('alert')}
            linkTitle={t('view_all')}
            link={'/alerts'}
         />
        <div style={{margin:'0px 10px'}}>
            <TableContainer  sx={{ 
                maxHeight: 255, 
                minHeight: 255, 
                "&::-webkit-scrollbar": {
                    width: 6,
                    scrollbarWidth:'thin'
                },
                "&::-webkit-scrollbar-track": {
                    backgroundColor: "white"
                },
                "&::-webkit-scrollbar-thumb": {
                    backgroundColor: "#ccc",
                    borderRadius: 2
                } 
            }}>
            <Table sx={{
                "& .MuiTableRow-root ":{
                    lineHeight: '2rem'
                },
                "& .MuiTableRow-root:hover": {
                    backgroundColor: "#028DD50D"
                }
                        
            }} 
            size="small"  
            stickyHeader 
            aria-label="sticky table">
            <TableHead>
                <TableRow>
                        <TableCell>{t('name')}</TableCell>
                        <TableCell align="left">{t('phone_number')}</TableCell>
                        <TableCell align="right">{t('education')}</TableCell>
                        <TableCell align="right">{t('exercise')}</TableCell>
                        <TableCell align="right">{t('questionnaire')}</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
            {rows && rows.map((row) => (

                <TableRow
                    key={row.userId}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                >
                    <TableCell component="th" scope="row">
                        <Link style={{ color: '#028DD5', textDecoration: 'inherit'}} to={`/user_details/${row.userId}`} > {row.firstName}</Link>
                        <Link style={{ color: '#028DD5', textDecoration: 'inherit'}} to={`/user_details/${row.userId}`} > {row.lastName}</Link>
                    </TableCell>
                    <TableCell  style={{textWrap: "nowrap"}}>{formatPhoneNumber(row.phone)}</TableCell>
                    <TableCell align="right">
                        <NumberCircle color={getStatusColor(row.compliance?.education)}>
                           
                            {completePercent(row.compliance.education)}
                        </NumberCircle>
                    </TableCell>
                    <TableCell align="right">
                        <NumberCircle  color={getStatusColor(row.compliance.exercise)}>
                            
                            {completePercent(row.compliance.exercise)}

                        </NumberCircle>
                    </TableCell>
                    <TableCell align="right">
                        <NumberCircle  color={getStatusColor(row.compliance.questionnaire)}>
                           
                            {completePercent(row.compliance.questionnaire)}

                        </NumberCircle>
                    </TableCell>
                </TableRow>
            ))}
            </TableBody>
            </Table>
            </TableContainer>
            {(userAlertStatus === API_STATUS.PENDING || userAlertStatus === API_STATUS.ERROR) &&
                <div> Loading the data...</div>
            }
        </div>
    </div>
  )
}

export default AlertBox